import MuiPagination from '@mui/material/Pagination';
import MuiPaginationItem from '@mui/material/PaginationItem';
import makeStyles from '@mui/styles/makeStyles';

import { darkGreen, white } from '@/theme/colors';

const useItemStyles = makeStyles({
  root: {
    color: darkGreen,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'var(--surfaceHoverOverlay)',
    },
  },
  selected: {
    color: white,
    backgroundColor: `${darkGreen} !important`,
  },
  ellipsis: {
    '&:hover': {
      backgroundColor: 'var(--surfaceHoverOverlay)',
    },
  },
});

function Pagination({ ...other }) {
  const itemStyles = useItemStyles();

  return (
    <MuiPagination
      {...other}
      renderItem={(item) => <MuiPaginationItem classes={itemStyles} {...item} />}
    />
  );
}

export default Pagination;
